<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <zd-scroll-board :config="config" />
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="最近一天的数据，按检验日期查询" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
import dateFormat from "date-fns/format";
import { ca } from "date-fns/locale";
export default {
  name: "defect-list",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      startCharts: null,
      dataList: this.beans,
      config: {
        headerHeight:30,
        startCharts: "",
        header: ["检验日期", "零件号", "数量", "缺陷类型"],
        headerBGC: "#018DCE",
        evenRowBGC: "#000D4A",
        rowNum: 6,
        columnWidth: [70, 100, 80,70,170],
        data: [],
      },
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        var data = [];
        for (var i = 0; i < this.dataList.length; i++) {
          var productionTime = this.dataList[i]["nokDefectList"]['productionTime'];
          var openedDate = "";
          if (productionTime > 0) {
            openedDate = this.dateFormat(productionTime, "yyyy-MM-dd");
          }
          var partNumber = this.dataList[i]["nokDefectList"]['partNumber'];
          var quantity = this.dataList[i]["quantity"];
          var categoryStr = this.dataList[i]["categoryStr"];
          if (categoryStr) {
            categoryStr = categoryStr.substring(0, categoryStr.length - 1);
          }
          var value = [openedDate, partNumber, quantity, categoryStr];
          data.push(value);
        }

        this.config = {
          index: true,
          indexHeader: "<span style='color:#fff;font-size:0.25rem'>序号</span>",
          startCharts: "",
          header: ["<span style='color:#fff;font-size:0.25rem'>检验日期</span>", "<span style='color:#fff;font-size:0.25rem'>零件号</span>", "<span style='color:#fff;font-size:0.25rem'>数量</span>", "<span style='color:#fff;font-size:0.25rem'>缺陷类型</span>"],
		  headerHeight:30,
          headerBGC: "#018DCE",
          evenRowBGC: "#000D4A",
          rowNum: 6,
          align: 'center',
         // columnWidth: [70, 100, 100,70],
          data: data,
        };
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    dateFormat(uninx, format) {
      return dateFormat(uninx, format);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>

<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/nok/component/defect-list.vue